import * as React from "react";

import ResearchNav from "./nav";
import wechatAuth from "./wechatAuth";

import config from "@/server/config";
import request from "@/server/request";

// const Toast = require("react-toast-mobile");

export default class ResearchCenter extends React.Component {
  public state = {
    plateList: [], // 产业链列表
    materialList: [], // 原料列表
    currentId: 0,
    currentText: "",
    selectedIndex: 0,
    expState: false, // 是否购买了价格中心
    specialcontent: '', // 特版内容
    plateId: 0,
  };

  public componentDidMount() {
    this.initView();
    wechatAuth();
    // window.addEventListener("scroll", this.scrollAction.bind(this));
  }

  private initView() {
    this.getUserExpOrderPermission();
  }

  // 是否购买
  private async getUserExpOrderPermission() {
    const data = await request({
      url: `${config.API}exp/wap/v2/getUserExpOrderPermission`,
      data: {
        activityType: 3
      }
    });

    // 没有收费 || 购买了此收费活动
    if (data.obj.expState || !data.obj.activityEnable) { 
      this.setState({
        expState: true
      });
      this.getPlateList();
      return
    }
   
    this.getSpecialcontent();
  }

  private async getSpecialcontent() {
    const r = await request({
      method: "get",
      url: `${config.API}api/specialcontent/get?code=005021005003`,
    });

    if (r.code === 0) {
      this.setState({
        specialcontent: r.data.formalContent
      })
      // html(r.data.formalContent);
    }
  }

  // 获取产业链数据
  private async getPlateList() {
    const r = await request({
      url: `${config.API}api/material/plate/list`,
    });

    if (r.code === 1 && r.obj.length > 0) {
      this.setState({
        currentText: r.obj[0].name,
        currentId: r.obj[0].id,
        plateId: r.obj[0].id,
        plateList: this.state.plateList.concat(r.obj || []),
      });
      this.getMaterialPriceList(r.obj[0].id);
    }
  }

  // 选择产业链
  private handleChange(event: any) {
    let select = event.target;
    let selectedIndex = select.selectedIndex;
    this.setState({
      currentId: event.target.value,
      // currentText: select.options[selectedIndex].text,
      selectedIndex: selectedIndex,
    });
  }

  // 获取原料报价
  private async getMaterialPriceList(id: number) {
    const state = this.state;
    this.setState({
      currentText: state.plateList[state.selectedIndex]["name"],
    });
    const r = await request({
      url: `${config.API}api/material/lately/price/list`,
      data: {
        plateId: id,
      },
    });

    if (r.code === 1 && r.obj.length > 0) {
      this.setState({
        materialList: r.obj,
        plateId: id,
      });
    }
  }

  public render() {
    const state = this.state;
    console.log(state)
    if(!state.expState) {
      return (
        <section>
          <ResearchNav index={3} />
          <div dangerouslySetInnerHTML={{__html: state.specialcontent}}></div>
        </section>
        );
    }

    const plateList = state.plateList.map((item: any) => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ));

    function formatDate(date: string) {
      var dateArr: string[] = date.split("-");
      return (
        (+dateArr[1] <= 9 ? dateArr[1][1] : dateArr[1]) +
        "月" +
        dateArr[2] +
        "日"
      );
    }

    const materialList = state.materialList.map((item: any) => (
      <div className="table-item" key={item.materialId}>
        <div className="table-item-name">
          <h3>{item.material}</h3>
          <span>{item.currencyValue}</span>
        </div>
        <table className="jgtable">
          <thead>
            <tr>
              {item.priceDataList.map((item: any, index: number) => (
                <th className="th01" key={item.day + index}>
                  {formatDate(item.day)}
                </th>
              ))}
              <th className="th02">曲线</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {item.priceDataList.map((item: any, index: number) => (
                <th className="th01" key={item.day + index}>
                  {item.price || 0}
                </th>
              ))}
              <td>
                <a
                  href={config.HZ_MB_API + "data/juece/price_center.html?" + `pid=${state.plateId}&mid=${item.materialId}`}
                  target="_blank"
                >
                  <img src="https://style.ibuychem.com/cmall/resource/material/images/qx.png" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    ));

    return (
      <section>
        <ResearchNav index={3} />
        {/* 内容 开始 */}
        <div className="jgtool">
          {/* 原料产业链下拉 */}
          <div className="sel">
            <select
              className="order-status"
              onChange={(event) => this.handleChange(event)}
              id="plateId"
              name="plateId"
            >
              {plateList}
            </select>
          </div>

          <button
            className="lsjg"
            onClick={() => this.getMaterialPriceList(state.currentId)}
          >
            查询
          </button>
        </div>
        <div className="zscan-con" id="priceList">
          <div className="jgtit">{state.currentText}</div>
          {materialList}
        </div>
        {/* 内容 结束 */}
      </section>
    );
  }
}
